import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../CustomComponents/Footer/Footer.jsx";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData.jsx";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles.jsx";
import CustomSearchFormTransport from "../../CustomComponents/SearchForm/CustomSearchFormActivities/CustomSearchFormTransport.jsx";
import Header from "../../CustomComponents/Header/Header.jsx";
import imgNotFound from "../../assets/images/single-image.png";
import Testimonial from "../../CustomComponents/Testimonial/Testimonial.jsx";
import Highlights from "../../CustomComponents/Highlights/Highlights.jsx";
import FilterActivities from "../../CustomComponents/FilterSection/FilterActivities.jsx";
import { formatIndianCurrency } from "../../utils/utils.js";
import FilterTransport from "../../CustomComponents/FilterSection/FilterTransport.jsx";
import './Transport.css'

function ListingTransportCabs() {
    const [footerDestinations, setFooterDestinations] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const [loader, setLoader] = useState(false);
    // const [bookingData, setBookingData] = useState({});
    const [showPriceDetails, setShowPriceDetails] = useState(false);

    const {
        transportData,
        bookingData
    } = location?.state || {};

    // useEffect(() => {
    //     const params = new URLSearchParams(location.search);

    //     const data = {
    //         adult: params.get("adult"),
    //         date: params.get("date"),
    //         year: params.get("year"),
    //         month: params.get("month"),
    //         startDestination: params.get("startdestination"),
    //         endDestination: params.get("enddestination"),
    //     };

    //     const travelDate = `${data.year}-${String(data.month).padStart(
    //         2,
    //         "0"
    //     )}-${String(data.date).padStart(2, "0")}`;
    //     setBookingData({ ...data, travelDate });
    // }, [location.search]);

    const transports = [
        {
            "id": 1,
            "supplierId": 2,
            "supplierName": "Eco Hospitality",
            "name": "Sedan",
            "type": "ertiga",
            "model": "2024",
            "seat": 6,
            "fuelType": "petrol",
            "status": "active",
            "featured": true,
            "sortOrder": 0,
            "isOnline": true
        },
        {
            "id": 2,
            "supplierId": 3,
            "supplierName": "Mountain Mysteries",
            "name": "MUV",
            "type": "innova-crysta",
            "model": "2018",
            "seat": 7,
            "fuelType": "petrol",
            "status": "active",
            "featured": true,
            "sortOrder": 1,
            "isOnline": true
        },
        {
            "id": 2,
            "supplierId": 3,
            "supplierName": "Mountain Mysteries",
            "name": "Crysta",
            "type": "innova-crysta",
            "model": "2018",
            "seat": 7,
            "fuelType": "petrol",
            "status": "active",
            "featured": true,
            "sortOrder": 1,
            "isOnline": true
        },
        {
            "id": 2,
            "supplierId": 3,
            "supplierName": "Mountain Mysteries",
            "name": "Tampo",
            "type": "innova-crysta",
            "model": "2018",
            "seat": 7,
            "fuelType": "petrol",
            "status": "active",
            "featured": true,
            "sortOrder": 1,
            "isOnline": true
        },
        {
            "id": 2,
            "supplierId": 3,
            "supplierName": "Mountain Mysteries",
            "name": "Urbania",
            "type": "innova-crysta",
            "model": "2018",
            "seat": 7,
            "fuelType": "petrol",
            "status": "active",
            "featured": true,
            "sortOrder": 1,
            "isOnline": true
        },
    ];

    const sendDataToParent = (data) => {
        console.log(data);
    };
    const navigateToCheckOutTransport = (item) => {
        navigate(
            `/checkout-transport`,
            {
                state: {
                    transportData: item,
                    bookingData: bookingData,
                    // activityPrice: displayedRate,
                    // selectedAddOns: selectedAddOns,
                    // totalAddonsCost: totalAddonsCost,
                    // totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
                    // markupData: markupData,
                    // activityPriceWithMarkup, activityPriceWithMarkup,
                },
            }
        );
    };

    return (
        <div id="transport">
            {/* <PageMetaData
        title="The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries"
        description="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        keywords="Hotels In Himachal Pradesh"
      />

      <OgMetaTitles
        title="The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries"
        type="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        url="https://www.mountainmysteries.com/accommodation/"
      /> */}
            <Header />
            <div className="common_bg common_padding">

                <div className="container ">
                    {/* <FilterActivities
                        sendDataToParent={sendDataToParent}
                        showDestinations={true}
                    /> */}
                    {/* <FilterTransport
                        sendDataToParent={sendDataToParent}
                    /> */}

                    <div className="itenarary_page">
                        <div className="itenarary_page_left">
                            <div className="itenarary_detail">
                                <div className="itenarary_detail_left">
                                    <h2>Delhi - Shimla(2N) - Manali(3N) - Delhi</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur. Lectus id sed ultrices morbi. Tempus pulvinar nunc mus et dolor in laoreet posuere. Morbi diam porttitor libero felis molestie leo nibh tincidunt. Platea varius nulla felis at tortor pellentesque augue dignissim. Laoreet ultricies massa amet ac. Ornare elementum aliquet at eu. Tempor scelerisque et nibh mi cursus mi sed. Tortor risus vel auctor et. Sit blandit aliquam tincidunt ipsum vel pellentesque augue dignissim.</p>
                                </div>

                                <div className="itenarary_destinations mt-10" >
                                    <div className="itenarary_destinations_item flex justify_content_between flex_gap_10">
                                        <p>Shimla</p>
                                        <div className="transport_card_dashed_line" style={{ width: '100%' }}>
                                            <div className="transport_circle"></div>
                                            <div className="dashed-line"></div>
                                            <div className="transport_circle"></div>
                                        </div>
                                        <p>Delhi</p>
                                        <button>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                <path d="M1 1.5L6 6.5L11 1.5" stroke="#333333" strokeWidth="1.5" />
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                                <p style={{ color: 'red', textAlign: 'center', textTransform: 'uppercase' }}>2 Nights</p>
                                <div className="itenarary_destinations mt-10" >
                                    <div className="itenarary_destinations_item flex justify_content_between flex_gap_10">
                                        <p>Delhi</p>
                                        <div className="transport_card_dashed_line" style={{ width: '100%' }}>
                                            <div className="transport_circle"></div>
                                            <div className="dashed-line"></div>
                                            <div className="transport_circle"></div>
                                        </div>
                                        <p>Manali</p>
                                        <button>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                <path d="M1 1.5L6 6.5L11 1.5" stroke="#333333" strokeWidth="1.5" />
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                                <p style={{ color: 'red', textAlign: 'center', textTransform: 'uppercase' }}>3 Nights</p>
                                <div className="itenarary_destinations mt-10" >
                                    <div className="itenarary_destinations_item flex justify_content_between flex_gap_10">
                                        <p>Manali</p>
                                        <div className="transport_card_dashed_line" style={{ width: '100%' }}>
                                            <div className="transport_circle"></div>
                                            <div className="dashed-line"></div>
                                            <div className="transport_circle"></div>
                                        </div>
                                        <p>Delhi</p>
                                        <button>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                <path d="M1 1.5L6 6.5L11 1.5" stroke="#333333" strokeWidth="1.5" />
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="itenarary_page_right">
                            <h2 className="mb-10">Vehicle Options</h2>
                            <div className="flex flex_gap_10 flex_wrap">
                                {transports && transports?.map((item, index) => (
                                    <div className="transport_cabs_card" key={index}>
                                        <div className="transport_cabs_card_top">
                                            <h4>{item?.name}</h4>
                                            <div className="flex align_items_center flex_gap_10">
                                                <div className="flex align_items_center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                                        <path d="M5.08333 4.00008C4.625 4.00008 4.23264 3.83689 3.90625 3.5105C3.57986 3.18411 3.41667 2.79175 3.41667 2.33341C3.41667 1.87508 3.57986 1.48272 3.90625 1.15633C4.23264 0.829943 4.625 0.666748 5.08333 0.666748C5.54167 0.666748 5.93403 0.829943 6.26042 1.15633C6.58681 1.48272 6.75 1.87508 6.75 2.33341C6.75 2.79175 6.58681 3.18411 6.26042 3.5105C5.93403 3.83689 5.54167 4.00008 5.08333 4.00008ZM9.66667 15.6667H4.29167C3.83333 15.6667 3.41319 15.5036 3.03125 15.1772C2.64931 14.8508 2.40972 14.4584 2.3125 14.0001L0.5 4.83341H2.20833L4.04167 14.0001H9.66667V15.6667ZM14.25 17.3334L11.8333 13.1667H6.04167C5.63889 13.1667 5.28819 13.0452 4.98958 12.8022C4.69097 12.5591 4.5 12.2362 4.41667 11.8334L3.5 7.37508C3.34722 6.70841 3.50347 6.11814 3.96875 5.60425C4.43403 5.09036 5 4.83341 5.66667 4.83341C6.15278 4.83341 6.59375 4.97925 6.98958 5.27091C7.38542 5.56258 7.63889 5.95842 7.75 6.45842L8.66667 10.6667H11.375C11.6667 10.6667 11.9375 10.7431 12.1875 10.8959C12.4375 11.0487 12.6389 11.2501 12.7917 11.5001L15.7083 16.5001L14.25 17.3334Z" fill="#1C1B1F" />
                                                    </svg>
                                                    4 Seater
                                                </div>
                                                <div className="flex align_items_center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                                                        <path d="M13.625 4.20825C13.25 4.58325 12.8194 4.86797 12.3333 5.06242C11.8472 5.25686 11.3611 5.35409 10.875 5.35409C10.3889 5.35409 9.90972 5.26033 9.4375 5.07283C8.96528 4.88533 8.54167 4.59714 8.16667 4.20825L6.60417 2.64575C6.39583 2.43742 6.15972 2.28117 5.89583 2.177C5.63194 2.07284 5.36111 2.02075 5.08333 2.02075C4.80556 2.02075 4.53472 2.07284 4.27083 2.177C4.00694 2.28117 3.77083 2.43742 3.5625 2.64575L2 4.20825L0.8125 3.02075L2.375 1.45825C2.75 1.08325 3.17361 0.802002 3.64583 0.614502C4.11806 0.427002 4.59722 0.333252 5.08333 0.333252C5.56944 0.333252 6.04514 0.427002 6.51042 0.614502C6.97569 0.802002 7.39583 1.08325 7.77083 1.45825L9.33333 3.02075C9.55556 3.24297 9.79861 3.40617 10.0625 3.51034C10.3264 3.6145 10.5972 3.66659 10.875 3.66659C11.1528 3.66659 11.4271 3.6145 11.6979 3.51034C11.9688 3.40617 12.2153 3.24297 12.4375 3.02075L14 1.45825L15.1875 2.64575L13.625 4.20825ZM13.625 8.37492C13.25 8.74992 12.8229 9.03117 12.3438 9.21867C11.8646 9.40617 11.3819 9.49992 10.8958 9.49992C10.4097 9.49992 9.92708 9.40617 9.44792 9.21867C8.96875 9.03117 8.54167 8.74992 8.16667 8.37492L6.60417 6.81242C6.39583 6.60409 6.15972 6.44784 5.89583 6.34367C5.63194 6.2395 5.36111 6.18742 5.08333 6.18742C4.80556 6.18742 4.53472 6.2395 4.27083 6.34367C4.00694 6.44784 3.77083 6.60409 3.5625 6.81242L2 8.37492L0.8125 7.20825L2.375 5.62492C2.75 5.24992 3.17361 4.96867 3.64583 4.78117C4.11806 4.59367 4.59722 4.49992 5.08333 4.49992C5.56944 4.49992 6.04514 4.59367 6.51042 4.78117C6.97569 4.96867 7.39583 5.24992 7.77083 5.62492L9.33333 7.18742C9.55556 7.40964 9.79861 7.57283 10.0625 7.677C10.3264 7.78117 10.5972 7.83325 10.875 7.83325C11.1528 7.83325 11.4271 7.78117 11.6979 7.677C11.9688 7.57283 12.2153 7.40964 12.4375 7.18742L14 5.62492L15.1875 6.81242L13.625 8.37492ZM13.6042 12.5416C13.2292 12.9166 12.8056 13.1978 12.3333 13.3853C11.8611 13.5728 11.3819 13.6666 10.8958 13.6666C10.4097 13.6666 9.92708 13.5728 9.44792 13.3853C8.96875 13.1978 8.54167 12.9166 8.16667 12.5416L6.58333 10.9791C6.375 10.7708 6.13889 10.6145 5.875 10.5103C5.61111 10.4062 5.34028 10.3541 5.0625 10.3541C4.78472 10.3541 4.51389 10.4062 4.25 10.5103C3.98611 10.6145 3.75 10.7708 3.54167 10.9791L1.97917 12.5416L0.8125 11.3749L2.375 9.79158C2.75 9.41658 3.17361 9.13534 3.64583 8.94784C4.11806 8.76034 4.59722 8.66658 5.08333 8.66658C5.56944 8.66658 6.04514 8.76034 6.51042 8.94784C6.97569 9.13534 7.39583 9.41658 7.77083 9.79158L9.33333 11.3541C9.55556 11.5763 9.80208 11.7395 10.0729 11.8437C10.3438 11.9478 10.6181 11.9999 10.8958 11.9999C11.1736 11.9999 11.4444 11.9478 11.7083 11.8437C11.9722 11.7395 12.2153 11.5763 12.4375 11.3541L14 9.79158L15.1667 10.9791L13.6042 12.5416Z" fill="#1C1B1F" />
                                                    </svg>
                                                    AC
                                                </div>
                                                <div className="flex align_items_center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M0.333984 13.6666V0.333252H2.00065V13.6666H0.333984ZM6.16732 13.6666V10.3333H7.83398V13.6666H6.16732ZM12.0007 13.6666V0.333252H13.6673V13.6666H12.0007ZM6.16732 8.66658V5.33325H7.83398V8.66658H6.16732ZM6.16732 3.66659V0.333252H7.83398V3.66659H6.16732Z" fill="#1C1B1F" />
                                                    </svg>
                                                    500 KMs Included
                                                </div>
                                            </div>
                                        </div>
                                        <div className="transport_cabs_card_bottom">
                                            <div className="transport_cabs_card_bottom_image">
                                                {item?.images ? <img src={item?.images} alt={item.name} />
                                                    : <img src={imgNotFound} alt='Image not found' />}
                                            </div>
                                            <div className="transport_cabs_card_bottom_content">
                                                <div className="transport_cabs_card_bottom_content_item">
                                                    <div>
                                                        <h4>Without AC</h4>
                                                        <button className="view_btn" onClick={() => setShowPriceDetails(true)}>Price Details</button>
                                                    </div>
                                                    <div className="transport_cabs_card_bottom_content_price flex align_items_center flex_gap_5">
                                                        <h5>{formatIndianCurrency(2700)}</h5>
                                                        <span className="font_11">+ GST (%)</span>
                                                        <div className="flex justify_content_end">
                                                            <button onClick={() => navigateToCheckOutTransport(item)} style={{ width: 'auto' }} className="primary_btn w-auto">Select Transport</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="transport_cabs_card_bottom_content_item">
                                                    <div>
                                                        <h4>With AC</h4>
                                                        <button className="view_btn" onClick={() => setShowPriceDetails(true)}>Price Details</button>
                                                    </div>
                                                    <div className="transport_cabs_card_bottom_content_price flex align_items_center flex_gap_5">
                                                        <h5>{formatIndianCurrency(2700)}</h5>
                                                        <span className="font_11">+ GST (%)</span>
                                                        <div className="flex justify_content_end">
                                                            <button onClick={() => navigateToCheckOutTransport(item)} style={{ width: 'auto' }} className="primary_btn w-auto">Select Transport</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="transport_card_listing_page_image">
                                            {item.images && item.images.length > 0 ?
                                                <img src={item.images[0]} alt={item.name} />
                                                : <img src={imgNotFound} alt='Image not found' />
                                            }
                                        </div>
                                        <div className="transport_card_listing_page_content">
                                            <h2>Delhi - Shimla(2N) - Manali(3N) -Delhi</h2>

                                            <div className="transport_card_destinations flex flex_gap_20 mt-10">
                                                <div className="transport_card_destinations_child">
                                                    <p>Start City</p>
                                                    <h6>Delhi</h6>
                                                </div>
                                                <div className="transport_card_dashed_line">
                                                    <div className="transport_circle"></div>
                                                    <div className="dashed-line"></div>
                                                    <div className="transport_circle"></div>
                                                </div>
                                                <div className="transport_card_destinations_child">
                                                    <p>Start City</p>
                                                    <h6>Delhi</h6>
                                                </div>
                                            </div>
                                            <div className="transport_options">
                                                <h5>Transport Options:</h5>

                                                <div className="flex flex_gap_10 align_items_center">
                                                    <div className="transport_options_cabs">
                                                        SEDAN
                                                    </div>
                                                    <div className="transport_options_cabs">
                                                        MUV
                                                    </div>  <div className="transport_options_cabs">
                                                        CRYSTA
                                                    </div>
                                                    <div className="transport_options_cabs">
                                                        TAMPO
                                                    </div>
                                                    <div className="transport_options_cabs">
                                                        URBANIA
                                                    </div>

                                                    <div className="transport_options_cabs_ac">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                                                            <path d="M7.30046 7.46674L6.33379 6.51675C6.21157 6.39452 6.05879 6.33341 5.87546 6.33341C5.69212 6.33341 5.53379 6.40008 5.40046 6.53341C5.27823 6.65563 5.21712 6.81119 5.21712 7.00008C5.21712 7.18897 5.27823 7.34452 5.40046 7.46674L6.83379 8.90008C6.96712 9.03341 7.12268 9.10008 7.30046 9.10008C7.47823 9.10008 7.63379 9.03341 7.76712 8.90008L10.6005 6.06675C10.7338 5.93341 10.7977 5.77786 10.7921 5.60008C10.7866 5.4223 10.7227 5.26675 10.6005 5.13341C10.4671 5.00008 10.3088 4.93063 10.1255 4.92508C9.94212 4.91952 9.78379 4.98341 9.65046 5.11675L7.30046 7.46674ZM5.43379 13.5001L4.46712 11.8667L2.63379 11.4667C2.46712 11.4334 2.33379 11.3473 2.23379 11.2084C2.13379 11.0695 2.0949 10.9167 2.11712 10.7501L2.30046 8.86675L1.05046 7.43341C0.939345 7.31119 0.883789 7.16675 0.883789 7.00008C0.883789 6.83341 0.939345 6.68897 1.05046 6.56675L2.30046 5.13341L2.11712 3.25008C2.0949 3.08341 2.13379 2.93063 2.23379 2.79175C2.33379 2.65286 2.46712 2.56675 2.63379 2.53341L4.46712 2.13341L5.43379 0.500079C5.52268 0.355635 5.6449 0.258412 5.80046 0.208412C5.95601 0.158412 6.11157 0.166746 6.26712 0.233412L8.00046 0.966746L9.73379 0.233412C9.88935 0.166746 10.0449 0.158412 10.2005 0.208412C10.356 0.258412 10.4782 0.355635 10.5671 0.500079L11.5338 2.13341L13.3671 2.53341C13.5338 2.56675 13.6671 2.65286 13.7671 2.79175C13.8671 2.93063 13.906 3.08341 13.8838 3.25008L13.7005 5.13341L14.9505 6.56675C15.0616 6.68897 15.1171 6.83341 15.1171 7.00008C15.1171 7.16675 15.0616 7.31119 14.9505 7.43341L13.7005 8.86675L13.8838 10.7501C13.906 10.9167 13.8671 11.0695 13.7671 11.2084C13.6671 11.3473 13.5338 11.4334 13.3671 11.4667L11.5338 11.8667L10.5671 13.5001C10.4782 13.6445 10.356 13.7417 10.2005 13.7917C10.0449 13.8417 9.88935 13.8334 9.73379 13.7667L8.00046 13.0334L6.26712 13.7667C6.11157 13.8334 5.95601 13.8417 5.80046 13.7917C5.6449 13.7417 5.52268 13.6445 5.43379 13.5001ZM6.30046 12.3001L8.00046 11.5667L9.73379 12.3001L10.6671 10.7001L12.5005 10.2667L12.3338 8.40008L13.5671 7.00008L12.3338 5.56675L12.5005 3.70008L10.6671 3.30008L9.70046 1.70008L8.00046 2.43341L6.26712 1.70008L5.33379 3.30008L3.50046 3.70008L3.66712 5.56675L2.43379 7.00008L3.66712 8.40008L3.50046 10.3001L5.33379 10.7001L6.30046 12.3001Z" fill="#009A50" />
                                                        </svg>
                                                        AC Facility
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="transport_card_listing_page_price">
                                            <span className="font_11">Starting From</span>
                                            <h5>{formatIndianCurrency(2700)}</h5>
                                            <span className="font_11">+ GST (%)</span>
                                            <div className="flex justify_content_end">
                                                <button onClick={() => navigateToCheckOutTransport(item)} style={{ width: 'auto', marginTop: '10px' }} className="primary_btn w-auto">View Transport</button>
                                            </div>
                                        </div> */}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showPriceDetails && (
                <div className="popup_backdrop">
                    <div className="popup_section">
                        <div className="agent">
                            <div>
                                <h6>
                                    <b>Cab Price</b>
                                </h6>
                                <p style={{ textAlign: "left" }}>
                                    {/* {items.meal_plan_name || "N/A"} */}
                                </p>
                            </div>
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                onClick={() => setShowPriceDetails(!showPriceDetails)}
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1 13L13 1"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                />
                                <path
                                    d="M13 13L1 1"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                />
                            </svg>
                        </div>
                        <hr />
                        <div>
                            <div className="agent">
                                <p>
                                    Without AC
                                </p>
                                <h6>
                                    {formatIndianCurrency(2700)}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
}

export default ListingTransportCabs;
